import React, { useState } from 'react';
import { Plus, Save, X, Pencil, Trash2, Trophy, ImageIcon, Search } from 'lucide-react';
import DisciplineSelector from './DisciplineSelector';
import ApparatusSelector from './ApparatusSelector';
import LevelSelectorSimple from './LevelSelectorSimple';
import '../../styles/shared.css';

const CATEGORY_TABS = [
  { key: 'acrobatic', discipline: 'acrobatic', category: '', name: 'ACRO', fullName: 'Gimnasia Acrobática', logo: '/acro.png' },
  { key: 'artistic-wag', discipline: 'artistic', category: 'wag', name: 'GAF', fullName: 'Artística Femenina', logo: '/gaf.png' },
  { key: 'artistic-mag', discipline: 'artistic', category: 'mag', name: 'GAM', fullName: 'Artística Masculina', logo: '/gam.png' },
  { key: 'gymnastics-for-all', discipline: 'gymnastics_for_all', category: '', name: 'GPT', fullName: 'Gimnasia Para Todos', logo: '/gpt.png' },
  { key: 'rhythmic', discipline: 'rhythmic', category: '', name: 'GR', fullName: 'Gimnasia Rítmica', logo: '/gr.png' },
  { key: 'trampoline', discipline: 'trampoline', category: '', name: 'GT', fullName: 'Gimnasia de Trampolín', logo: '/gt.png' },
  { key: 'aerobic', discipline: 'aerobic', category: '', name: 'AER', fullName: 'Aeróbica', logo: '/aer.png' },
  { key: 'parkour', discipline: 'parkour', category: '', name: 'PK', fullName: 'Parkour', logo: '/pk.png' },
];

const EventForm = ({
  showEventForm,
  editingEvent,
  eventForm,
  setEventForm,
  addEvent,
  cancelEventForm,
  uploadingImage,
  handleFileChange,
  clearImagePreview,
  events,
  editEvent,
  deleteEvent,
  setShowEventForm,
  setEditingEvent,
  clubs = [],
  judges = []
}) => {
  const [judgeSearch, setJudgeSearch] = useState('');
  const [clubSearch, setClubSearch] = useState('');
  if (!showEventForm) {
    return (
      <div className="card">
        <div className="card-header">
          <h2>Gestión de Eventos</h2>
          <button
            onClick={() => {
              setEditingEvent(null);
              setEventForm({ 
                name: '', 
                date: '', 
                location: '', 
                discipline: '',
                category: '',
                apparatus: [],
                selectedClubs: [],
                selectedJudges: [],
                imageFile: null, 
                imagePreview: null 
              });
              setShowEventForm(true);
            }}
            className="btn btn-primary"
          >
            <Plus size={16} />
            Nuevo Evento
          </button>
        </div>

        <div className="event-list">
          {events.map(event => (
            <div key={event.id} className="event-item" style={{ opacity: event.is_active ? 1 : 0.6 }}>
              <div className="event-info">
                {event.image_url ? (
                  <img src={event.image_url} alt={event.name} className="event-image" />
                ) : (
                  <div className="event-icon">
                    <Trophy size={24} />
                  </div>
                )}
                <div>
                  <div className="event-name">
                    {event.name}
                    <span style={{ marginLeft: '8px', fontSize: '0.75rem', padding: '2px 8px', borderRadius: '4px', backgroundColor: event.is_active ? '#d1fae5' : '#fee2e2', color: event.is_active ? '#065f46' : '#991b1b' }}>
                      {event.is_active ? '✓ Activo' : '✗ Inactivo'}
                    </span>
                  </div>
                  <div className="event-details">
                    {event.date} - {event.location}
                  </div>
                  {event.discipline && (
                    <div className="event-details" style={{ fontSize: '12px', marginTop: '4px' }}>
                      📋 {event.discipline}{event.category ? ` • ${event.category}` : ''}
                    </div>
                  )}
                </div>
              </div>
              <div className="event-actions">
                <button onClick={() => editEvent(event)} className="btn-icon" title="Editar evento">
                  <Pencil size={16} />
                </button>
                <button onClick={() => deleteEvent(event.id)} className="btn-icon" title="Eliminar evento">
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h2>{editingEvent ? 'Editar Evento' : 'Nuevo Evento'}</h2>
      </div>
      
      <div className="form-container">
        <div className="form-group">
          <label>Nombre del Evento</label>
          <input
            type="text"
            placeholder="Nombre del evento"
            value={eventForm.name}
            onChange={(e) => setEventForm({...eventForm, name: e.target.value})}
            className="input-field"
          />
        </div>

        {/* Category Image Tabs */}
        <div className="form-group">
          <label>Categoría Rápida</label>
          <div style={{
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            padding: '12px',
            background: '#f5f7fa',
            borderRadius: '12px',
            border: '1.5px solid #e2e8f0'
          }}>
            {CATEGORY_TABS.map(tab => {
              const isActive = eventForm.discipline === tab.discipline && 
                (tab.category === '' || eventForm.category === tab.category);
              return (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => {
                    setEventForm(prev => ({
                      ...prev,
                      discipline: tab.discipline,
                      category: tab.category,
                      apparatus: []
                    }));
                  }}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '12px 16px',
                    border: isActive ? '2px solid #8b5cf6' : '1.5px solid #e2e8f0',
                    borderRadius: '12px',
                    background: isActive ? 'linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%)' : 'white',
                    cursor: 'pointer',
                    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                    flex: '1 1 80px',
                    minWidth: '80px',
                    boxShadow: isActive ? '0 4px 14px rgba(139, 92, 246, 0.2)' : '0 1px 3px rgba(0,0,0,0.04)',
                    transform: isActive ? 'translateY(-2px)' : 'none',
                  }}
                >
                  <img 
                    src={tab.logo} 
                    alt={tab.name} 
                    style={{ 
                      width: '36px', 
                      height: '36px', 
                      objectFit: 'contain',
                      opacity: isActive ? 1 : 0.6,
                      filter: isActive ? 'none' : 'grayscale(30%)',
                      transition: 'all 0.25s ease'
                    }} 
                  />
                  <span style={{ 
                    fontSize: '0.7rem', 
                    fontWeight: 700, 
                    color: isActive ? '#4338ca' : '#64748b',
                    letterSpacing: '0.05em'
                  }}>
                    {tab.name}
                  </span>
                  <span style={{ 
                    fontSize: '0.6rem', 
                    color: isActive ? '#8b5cf6' : '#94a3b8',
                    textAlign: 'center',
                    lineHeight: '1.2'
                  }}>
                    {tab.fullName}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <DisciplineSelector
          selectedDiscipline={eventForm.discipline || ''}
          selectedCategory={eventForm.category || ''}
          onDisciplineChange={(discipline) => {
            console.log('EventForm - onDisciplineChange llamado con:', discipline);
            setEventForm(prev => {
              const newForm = {...prev, discipline, category: '', apparatus: []};
              console.log('EventForm - nuevo form será:', newForm);
              return newForm;
            });
          }}
          onCategoryChange={(category) => {
            console.log('EventForm - onCategoryChange llamado con:', category);
            setEventForm(prev => {
              const newForm = {...prev, category, apparatus: []};
              console.log('EventForm - nuevo form será:', newForm);
              return newForm;
            });
          }}
        />

        <ApparatusSelector
          discipline={eventForm.discipline}
          category={eventForm.category}
          selectedApparatus={eventForm.apparatus || []}
          onApparatusChange={(apparatus) => 
            setEventForm({...eventForm, apparatus})
          }
          allowMultiple={true}
        />

        <div className="form-group">
          <label>Niveles del Evento</label>
          <LevelSelectorSimple
            selectedLevelIds={eventForm.selectedLevels || []}
            onChange={(levels) => setEventForm({...eventForm, selectedLevels: levels})}
          />
        </div>
        
        <div className="form-group">
          <label>Fecha</label>
          <input
            type="date"
            value={eventForm.date}
            onChange={(e) => setEventForm({...eventForm, date: e.target.value})}
            className="input-field"
          />
        </div>
        
        <div className="form-group">
          <label>Ubicación (opcional)</label>
          <input
            type="text"
            placeholder="Ubicación"
            value={eventForm.location}
            onChange={(e) => setEventForm({...eventForm, location: e.target.value})}
            className="input-field"
          />
        </div>

        <div className="form-group">
          <label>Clubes Participantes (opcional)</label>
          <div>
            {/* Búsqueda y selector de clubes */}
            <div style={{ marginBottom: '12px' }}>
              <div style={{ position: 'relative', marginBottom: '12px' }}>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <Search size={16} style={{ position: 'absolute', left: '10px', color: '#9ca3af' }} />
                  <input
                    type="text"
                    placeholder="Buscar club por nombre..."
                    value={clubSearch}
                    onChange={(e) => setClubSearch(e.target.value)}
                    className="input-field"
                    style={{ paddingLeft: '36px' }}
                  />
                </div>
                
                {/* Dropdown de clubes filtrados */}
                {clubSearch && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    maxHeight: '250px',
                    overflowY: 'auto',
                    background: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '6px',
                    marginTop: '4px',
                    zIndex: 100,
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}>
                    {clubs
                      .filter(club => 
                        club.name.toLowerCase().includes(clubSearch.toLowerCase()) ||
                        (club.location && club.location.toLowerCase().includes(clubSearch.toLowerCase()))
                      )
                      .map(club => (
                        <button
                          key={club.id}
                          type="button"
                          onClick={() => {
                            const currentClubs = eventForm.selectedClubs || [];
                            if (!currentClubs.includes(club.id)) {
                              setEventForm({...eventForm, selectedClubs: [...currentClubs, club.id]});
                            }
                            setClubSearch('');
                          }}
                          style={{
                            width: '100%',
                            padding: '10px 12px',
                            textAlign: 'left',
                            background: 'none',
                            border: 'none',
                            borderBottom: '1px solid #f3f4f6',
                            cursor: 'pointer',
                            fontSize: '0.9rem'
                          }}
                          onMouseEnter={(e) => e.target.style.background = '#f9fafb'}
                          onMouseLeave={(e) => e.target.style.background = 'none'}
                        >
                          <div style={{ fontWeight: '500', color: '#111827' }}>{club.name}</div>
                          <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{club.location || 'Sin ubicación'}</div>
                        </button>
                      ))}
                  </div>
                )}
              </div>
            </div>

            {/* Clubes seleccionados */}
            {(eventForm.selectedClubs || []).length > 0 && (
              <div style={{ 
                background: '#f9fafb', 
                border: '1px solid #e5e7eb', 
                borderRadius: '6px', 
                padding: '12px',
                marginBottom: '12px'
              }}>
                <div style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                  Clubes seleccionados ({eventForm.selectedClubs.length}):
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {eventForm.selectedClubs.map(clubId => {
                    const club = clubs.find(c => c.id === clubId);
                    return club ? (
                      <div
                        key={club.id}
                        style={{
                          background: '#eef2ff',
                          border: '1px solid #8b5cf6',
                          borderRadius: '20px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontSize: '0.875rem'
                        }}
                      >
                        <span>{club.name}</span>
                        <button
                          type="button"
                          onClick={() => {
                            const updated = eventForm.selectedClubs.filter(id => id !== clubId);
                            setEventForm({...eventForm, selectedClubs: updated});
                          }}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#8b5cf6',
                            padding: '0'
                          }}
                        >
                          <X size={14} />
                        </button>
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            )}

            {clubs.length === 0 && (
              <p style={{ color: '#999', fontSize: '14px' }}>No hay clubes disponibles</p>
            )}
          </div>
        </div>

        <div className="form-group">
          <label>Jueces Asignados (opcional)</label>
          <div>
            {/* Búsqueda y selector de jueces */}
            <div style={{ marginBottom: '12px' }}>
              <div style={{ position: 'relative', marginBottom: '12px' }}>
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                  <Search size={16} style={{ position: 'absolute', left: '10px', color: '#9ca3af' }} />
                  <input
                    type="text"
                    placeholder="Buscar juez por nombre..."
                    value={judgeSearch}
                    onChange={(e) => setJudgeSearch(e.target.value)}
                    className="input-field"
                    style={{ paddingLeft: '36px' }}
                  />
                </div>
                
                {/* Dropdown de jueces filtrados */}
                {judgeSearch && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    maxHeight: '250px',
                    overflowY: 'auto',
                    background: 'white',
                    border: '1px solid #e5e7eb',
                    borderRadius: '6px',
                    marginTop: '4px',
                    zIndex: 100,
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                  }}>
                    {judges
                      .filter(judge => 
                        judge.name.toLowerCase().includes(judgeSearch.toLowerCase()) ||
                        judge.email.toLowerCase().includes(judgeSearch.toLowerCase())
                      )
                      .map(judge => (
                        <button
                          key={judge.id}
                          type="button"
                          onClick={() => {
                            const currentJudges = eventForm.selectedJudges || [];
                            if (!currentJudges.includes(judge.id)) {
                              setEventForm({...eventForm, selectedJudges: [...currentJudges, judge.id]});
                            }
                            setJudgeSearch('');
                          }}
                          style={{
                            width: '100%',
                            padding: '10px 12px',
                            textAlign: 'left',
                            background: 'none',
                            border: 'none',
                            borderBottom: '1px solid #f3f4f6',
                            cursor: 'pointer',
                            fontSize: '0.9rem'
                          }}
                          onMouseEnter={(e) => e.target.style.background = '#f9fafb'}
                          onMouseLeave={(e) => e.target.style.background = 'none'}
                        >
                          <div style={{ fontWeight: '500', color: '#111827' }}>{judge.name}</div>
                          <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>{judge.email}</div>
                        </button>
                      ))}
                  </div>
                )}
              </div>
            </div>

            {/* Jueces seleccionados */}
            {(eventForm.selectedJudges || []).length > 0 && (
              <div style={{ 
                background: '#f9fafb', 
                border: '1px solid #e5e7eb', 
                borderRadius: '6px', 
                padding: '12px',
                marginBottom: '12px'
              }}>
                <div style={{ fontSize: '0.875rem', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                  Jueces seleccionados ({eventForm.selectedJudges.length}):
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {eventForm.selectedJudges.map(judgeId => {
                    const judge = judges.find(j => j.id === judgeId);
                    return judge ? (
                      <div
                        key={judge.id}
                        style={{
                          background: '#dbeafe',
                          border: '1px solid #0284c7',
                          borderRadius: '20px',
                          padding: '6px 12px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontSize: '0.875rem'
                        }}
                      >
                        <span>{judge.name}</span>
                        <button
                          type="button"
                          onClick={() => {
                            const updated = eventForm.selectedJudges.filter(id => id !== judgeId);
                            setEventForm({...eventForm, selectedJudges: updated});
                          }}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#0284c7',
                            padding: '0'
                          }}
                        >
                          <X size={14} />
                        </button>
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            )}

            {judges.length === 0 && (
              <p style={{ color: '#999', fontSize: '14px' }}>No hay jueces disponibles</p>
            )}
          </div>
        </div>
        
        <div className="form-group">
          <label>Imagen del Evento (opcional)</label>
          <div className="image-upload">
            <label className="btn btn-secondary">
              <ImageIcon size={14} />
              {eventForm.imagePreview ? 'Cambiar Imagen' : 'Seleccionar Imagen'}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, setEventForm)}
                style={{ display: 'none' }}
              />
            </label>
            
            {eventForm.imagePreview && (
              <button
                onClick={() => clearImagePreview(setEventForm)}
                className="btn-icon danger"
              >
                <X size={14} />
                Eliminar
              </button>
            )}
          </div>
          
          {eventForm.imagePreview && (
            <div className="image-preview">
              <div className="preview-label">Vista previa:</div>
              <img
                src={eventForm.imagePreview}
                alt="Preview"
                className="preview-image"
              />
            </div>
          )}
        </div>

        <div className="form-group" style={{ marginTop: '24px', padding: '16px', background: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <input
              type="checkbox"
              id="is_active"
              checked={eventForm.is_active !== false}
              onChange={(e) => setEventForm({...eventForm, is_active: e.target.checked})}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            <label htmlFor="is_active" style={{ cursor: 'pointer', margin: 0, fontWeight: '500' }}>
              {eventForm.is_active !== false ? '✓' : '✗'} Evento Activo
            </label>
            <span style={{ fontSize: '0.875rem', color: '#6b7280', marginLeft: 'auto' }}>
              {eventForm.is_active !== false ? 'Los usuarios públicos verán este evento' : 'Solo administradores pueden ver este evento'}
            </span>
          </div>
        </div>

        <div className="form-actions">
          <button
            onClick={addEvent}
            disabled={uploadingImage}
            className="btn btn-success"
          >
            <Save size={16} />
            {uploadingImage ? 'Subiendo...' : (editingEvent ? 'Actualizar' : 'Guardar')}
          </button>
          <button
            onClick={cancelEventForm}
            disabled={uploadingImage}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventForm;